import React from "react";
import './Plans.css'
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import {Link} from 'react-scroll'

const Plans = () => {
  return (
    <div className="plans-container" id="plans">
    <div className="blur plans-blur1" />
    <div className="blur plans-blur2" />

      <div className="programs-header" style={{ gap: "2rem" }}>
        <span className="stroke-text">READY TO START</span>
        <span>YOUR JOURNEY</span>
        <span className="stroke-text">WITH US ?</span>
      </div>
      {/* plans card */}
      <div className="plans" >
        {plansData.map((plan, i) => (
          <div className="plan" key={i}>
            {plan.icon}
            <span>{plan.name}</span>
            <span>₹ {plan.price}</span>
            <div className="features">
              {plan.features.map((feature, i) => (
                <div className="feature" key={i}>
                  <img src={whiteTick} alt="" />
                  <span>{feature}</span>
                </div>
              ))}
            </div>
            <div>
              <span>see more benefits -&gt; </span>
            </div>
            <button className="btn"><Link 
              spy={true}
              smooth={true} to='email'>Join now</Link></button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Plans;
